import { searchInputVariants } from '@web/modules/core'
import React, { Dispatch, RefObject, SetStateAction, useEffect, useState } from 'react'
import { Button, Input, Loading } from '@tecsinapse/cortex-react'
import { IoSearchOutline } from 'react-icons/io5'

interface SearchInputProps {
  inputRef: RefObject<HTMLInputElement | null>
  label?: string
  placeholder?: string
  value: string
  setValue: Dispatch<SetStateAction<string | null>>
  isSubmitting?: boolean
  onChange?: (value: string) => void
  onClick?: (value: string) => void
}

const { inputFace } = searchInputVariants()

const SearchInput = ({
  inputRef,
  label,
  placeholder,
  value,
  setValue,
  isSubmitting = false,
  onChange,
  onClick
}: SearchInputProps) => {
  useEffect(() => {
    if (onChange) {
      onChange(value)
    }
    // add onChange dep = infinite loop
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value])

  useEffect(() => {
    inputRef.current?.focus()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleEnterKey = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter' && onClick && value.length > 3) {
      onClick(value)
    }
  }

  return (
    <div className='flex flex-row w-full space-x-mili'>
      <Input.Search
        ref={inputRef}
        variants={{ className: inputFace() }}
        placeholder={placeholder}
        label={label}
        onChange={event => setValue(event.target.value)}
        onKeyDown={handleEnterKey}
        disabled={isSubmitting}
        defaultValue={value}
      />

      {onClick && (
        <Button
          className='h-11'
          variants={{
            intent: 'primary',
            size: 'square'
          }}
          onClick={() => onClick?.(value)}
          disabled={value.length < 3 || isSubmitting}
        >
          <div className={'flex'}>{isSubmitting ? <Loading /> : <IoSearchOutline className={'text-centi'} />}</div>
        </Button>
      )}
    </div>
  )
}

export default SearchInput
